<template lang="html">
  <div class="stats__container">
    <div class="stats__content">
      <div class="stats__heading">
        <Heading color="orange" size="h6">
          {{ $t('pages.reviews.stats.subtitle') }}
        </Heading>
        <Heading size="h2">
          {{ $t('pages.reviews.stats.title') }}
        </Heading>
      </div>
      <div class="stats__table">
        <div class="stats__row">
          <Card
            class="stats__card"
            :value="7842"
            :description="$t('pages.reviews.stats.card_1.description')"
            color="pink"
            icon="house"
          />
          <Card
            class="stats__card"
            :value="1"
            :description="$t('pages.reviews.stats.card_2.description')"
            color="green"
            icon="collaborators"
          />
        </div>
        <div class="stats__row">
          <Card
            class="stats__card"
            :value="120208427"
            :description="$t('pages.reviews.stats.card_3.description')"
            color="purple"
            icon="rocket"
          />
          <Card
            class="stats__card"
            :value="47050"
            :description="$t('pages.reviews.stats.card_4.description')"
            color="pink"
            icon="player"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from './Card.vue'

import Heading from '@/components/common/Heading/Heading'

export default {
  components: {
    Card,
    Heading
  }
}
</script>

<style lang="scss" scoped>
.stats {
  &__container {
    width: 100%;
    padding: $gap * 3.5 $gap;

    @include display-less(phablet) {
      padding: $gap * 5 $gap;
    }

  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: $gap * 2;
    margin: 0 auto;
    width: 100%;
    max-width: 1120px;
    gap: $gap * 1.5;
  }

  &__heading {
    display: flex;
    flex-direction: column;
    gap: $gap * 0.5;
  }

  &__table {
    display: flex;
    flex-direction: column;
    gap: $gap * 1.5;
  }

  &__row {
    display: flex;
    flex-direction: row;
    gap: $gap * 1.5;
    flex: 1 1 0;
    width: 100%;

    @include display-less(desktop) {
      flex-direction: column;
    }
  }

  &__card {
    flex: 1 1 0;
    min-height: 271px;
    max-height: 320px;
    @include display-less(desktop) {
      flex: unset;
    }
  }
}
</style>
